const features = [
  {
    title: "Emergency QR Health Sharing",
    description: "Store critical medical details—chronic diseases, blood type, allergies, medications, emergency contacts. Share instantly with first responders via QR code when seconds count.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
    badge: "Health"
  },
  {
    title: "Always-Ready Medical Info",
    description: "Whether traveling, at home, or on the road, your critical health information is accessible 24/7. First responders get accurate data instantly, improving emergency treatment.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    badge: "Health"
  },
  {
    title: "Smart Expense Splitting",
    description: "Track who owes what when sharing costs. Scan receipts with AI, allocate items to people, and generate shareable summaries. Perfect for group dinners, trips, or roommates.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    badge: "Economics"
  },
  {
    title: "Cash Flow Insights",
    description: "Understand your money flow with visual dashboards. Plan recurring expenses, track spending patterns, see future balance projections, and receive weekly email summaries.",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
      </svg>
    ),
    badge: "Economics"
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-gray-900">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Key Features
          </h2>
          <p className="text-xl text-gray-400">
            Everything you need to manage your health and finances
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-secondary rounded-lg p-6 transform hover:scale-105 transition duration-300"
            >
              <div className="flex items-center justify-between mb-4">
                <div className="text-primary-light">
                  {feature.icon}
                </div>
                <span className={`text-xs font-semibold px-2 py-1 rounded ${
                  feature.badge === 'Health' ? 'bg-red-500/20 text-red-300' : 
                  feature.badge === 'Economics' ? 'bg-green-500/20 text-green-300' : 
                  'bg-blue-500/20 text-blue-300'
                }`}>
                  {feature.badge}
                </span>
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-400">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 